import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "@/lib/utils"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

/**
 * Onde os popovers de um trecho da tela vão parar. Dentro de um Sheet/Dialog modal, o Radix
 * trava a rolagem de tudo que está FORA do conteúdo dele — e o popover, portalado no `body`,
 * fica de fora: a lista de opções não rolava no toque. Quem hospeda filtros num Sheet (a folha
 * "Filtros" da `BarraDaLista`) fornece o próprio conteúdo como destino.
 */
export const DestinoDosPopovers = React.createContext<HTMLElement | null>(null)

const PopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    container?: HTMLElement | null;
  }
>(({ className, align = "center", sideOffset = 4, container, ...props }, ref) => {
  const destino = React.useContext(DestinoDosPopovers)
  return (
  <PopoverPrimitive.Portal container={container ?? destino}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      // z-[1500]: acima do Dialog (z-[1400]), como select e tooltip — sem isto o popover
      // aberto dentro de um dialog ficava por trás dele.
      className={cn(
        "z-[1500] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
  )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
